module.exports = __webpack_public_path__ + "3b37fcf53b8c0c63e431a36064b09c25.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/seating-map-minus.svg
// module id = VgON
// module chunks = 5